import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
export const useAddCredit = ()=>{
    const { api } = useStoreActions();
    const { mutateAsync } = useMutationState({
        mutationFn: (param)=>{
            let { relationshipId, data } = param;
            if (!data.note) {
                delete data.note;
            }
            return api.billing.addCredit(relationshipId, data);
        }
    });
    return {
        addCredit: mutateAsync
    };
};
